import { Util } from '@libs/utilities/util';

import { EnumOutputFormat, IOutputFormatOptions } from '../kw-workbench.interface';


export class OutputFormatPipeHelper {


	processOutputFormatting(groupedKeywords: string[][], outputFormat: IOutputFormatOptions): string {

		//0 - is the formatting option valid?
		if (!Util.Enum.isValid(EnumOutputFormat, outputFormat.format)) throw new Error(`OutputFormatPipeHelper => processOutputFormatting => FATAL ERROR: the outputFormat of "${outputFormat.format}" is invalid (valid are: "${Util.Enum.values(EnumOutputFormat).join(', ')}")`);

		//1 - format the text of the keywords
		switch (outputFormat.format) {
			case EnumOutputFormat.CommaWithSpace:
				return this.formatSeparateBy(groupedKeywords, ', ');

			case EnumOutputFormat.OnlySpace:
				return this.formatSeparateBy(groupedKeywords, ' ');

			case EnumOutputFormat.SeparateBy:
				const customSeparator: string = !Util.String.isEmpty(outputFormat.customSeparator) ? outputFormat.customSeparator : ', ';
				return this.formatSeparateBy(groupedKeywords, customSeparator);

			case EnumOutputFormat.OnePerLine:
				return this.formatSeparateBy(groupedKeywords, '\n');

			default:
				throw new Error(`OutputFormatPipeHelper => processOutputFormatting => FATAL ERROR: output formatting behavior of "${outputFormat.format}" is not defined`);
		}
	}


	/**------------------------------------------------------
	 * Helper Functions
	 */
	private formatSeparateBy(groupedKeywords: string[][], wordSeparator: string, groupSeparator: string = '\n\n'): string {

		//0 - join the keywords in a group to a text
		const keywordGroupAsText: string[] = groupedKeywords.map((group: string[]) => group.join(wordSeparator));

		//1 - join the groups together into one big text
		return keywordGroupAsText.join(groupSeparator);
	}
}
